// extracted by mini-css-extract-plugin
export default {"topDisclaimer":"TopDisclaimer_topDisclaimer__erk+t"};